const Hamburger = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_168_7123)">
        <rect
          x="0.367188"
          y="19.8843"
          width="9.85861"
          height="1.63"
          rx="0.815"
          fill="white"
        />
        <rect
          x="0.367188"
          y="11.6687"
          width="23.0034"
          height="1.63"
          rx="0.815"
          fill="white"
        />
        <rect
          x="13.5117"
          y="3.45312"
          width="9.85861"
          height="1.63"
          rx="0.815"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_168_7123">
          <rect width="24" height="24" rx="2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Hamburger;
